<template>
	<b-container class="show-document" style="width:1000px">
		<div class="actions mb-2 mt-2 hidden-print">
			<div class="pull-left">
				<b-button @click="goBackToFrom" variant="outline-dark">
                    <i class="fa fa-chevron-left"></i> {{ $t('back')}}
				</b-button>
			</div>
			<div class="pull-right">
				<b-button
					variant="outline-primary"
					@click="excelSave"
					class="mr-2"
				>
					{{ $t('excel-export.download-excel') }}
				</b-button>
				<b-button
					variant="outline-dark"
					@click="print"
					class="mr-2"
				>
					<i class="fa fa-print"></i>
					{{$t('pricing.print')}}
				</b-button>

			</div>
			<div class="clearfix"></div>

		</div>
		<div class="doc-body">
			<b-card style="
            padding:40px" >
                <div class="wrapped">
                    <header>
                        <h4 class="mt-4 text-center " style="font-size:18px; font-weight:bold">
                        Seria AVGF 2 nr. {{saleForDocument.saleNumber}}</h4>
                        <b-row>
                            <b-col cols="4">
                                <ul style="list-style:none" class="left-box">
                                    <li>Furnizor:  AVIGTEX SRL</li>
                                    <li>Nr. de inmatriculare in Registul </li>
                                    <li>comertului/anut J22/155/2018	</li>
                                    <li>C.I.F: RO 38743835 </li>
                                    <li>Sediu: lasi, Sos: Bucium 23 </li>
                                    <li>BI. T1, Et.2</li>
                                    <li>Tel: +40752411079</li>
                                    <li>Email: avigatex@gmail.com</li>
                                    <li>Captal social :200 lei </li>
                                    <li>Judetul: lasi </li>
                                    <li>Banca: ING</li>
                                    <li>Contut: RO29INGB0000999907605674</li>
                                </ul>
                            </b-col>
                            <b-col cols="4">
                                <div class="pt-5 pl-4 pr-4 mt-4 mb-4">
                                    <h2 class="text-center">
                                    <strong>
                                        FACTURĂ FISCALĂ
                                    </strong>
                                    </h2>
                                </div>
                                <div class="bottom-fiscal">
                                    <ul style="list-style:none;font-size :12.5px" class="pt-2 pl-2 pr-2">
                                        <li>Nr. Facturii: {{saleForDocument.saleNumber}}</li>
                                        <li>Data (ziua, luna, anul): {{saleForDocument.saleDate}}</li>
                                        <li>Nr.avizului de insotire a marfii.....................</li>
                                         <li class="text-center">
											(daca este cazuf)
										 </li>
                                    </ul>
                                </div>
                            </b-col>
                            <b-col cols="4" class="pl-0">
                                 <ul style="list-style:none" class="mt-4 ul-third" >
                                    <li><span >Cumparatur   
										{{saleForDocument.contragentName}} </span>
										<!-- <br> -->
									<!-- <span style="font-size:10px; ">	(dhgsagdsajdsh)</span>  -->
									</li>
									<!-- <li>..........................................................................</li> -->
                                    <li>Nr. Ord. Reg. Com/en: ..................................</li>
                                    <li>C.U.I:  ................................................................ </li>
                                    <li>Sedniul: {{saleForDocument.contragentAddress}} </li>
                                    <!-- <li>..........................................................................</li> -->
                                    <li>Judejul: ............................................................</li>
                                    <li>Condul: ...........................................................</li>
                                    <li>Banca: ............................................................. </li>
                                </ul>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="4" class="text-center">
                                <span >Cota.T.V.A: 19%</span>
                            </b-col>
                        </b-row>
                    </header>
                      <div class="body-wrapped">
                          <div class="c-1">
                                <div class="inner-dev">
                                    Nr.
                                    <br>
                                    crt
                                </div>
                                <div class="inner-dev-2">
                                    0
                                </div>
                                <div  class="td" style="justify-content:center"
                                v-for="(item, index) 
                                 in saleForDocument.saleItems"
                                :key="index" >
                                    {{index+1}}
                                </div>
                          </div>
                          <div class="c-2">
                                <div class="inner-dev">
                                    Denumirea produselor 
                                    <br>
                                    sau a serviciilor
                                </div>
                                <div class="inner-dev-2">
                                    1
                                </div>
                                <div class="td pl-2" v-for="(item, index) 
                                 in saleForDocument.saleItems"
                                :key="index" >
                                    {{item.name.substring(0, 35)}}
                                </div>
                          </div>
                          <div class="c-3">
                                <div class="inner-dev">
                                    U.M
                                </div>
                                <div class="inner-dev-2">
                                    2
                                </div>
                                 <div class="td" style="justify-content:center"
                                 v-for="(item, index) 
                                 in saleForDocument.saleItems"
                                :key="index" >
                                  {{ item.unitName.substring(0, 6) }}
                                </div>
                          </div>
                          <div class="c-4">
                                <div class="inner-dev">
                                    Cantitatea
                                </div>
                                <div class="inner-dev-2">
                                    3
                                </div>
                                <div  class="td" style="justify-content:center"
                                v-for="(item, index) 
                                 in saleForDocument.saleItems"
                                :key="index" >
                                    {{item.count}}
                                </div>
                          </div>
                          <div class="c-5">
                                <div class="inner-dev">
                                    Pret unitar
                                    <br>
                                    (fara TVA)
                                    <br>
                                    -lei-
                                </div>
                                <div class="inner-dev-2">
                                    4
                                </div>
                                 <div class="td" style="justify-content:center"
                                 v-for="(item, index) 
                                 in saleForDocument.saleItems"
                                :key="index" >
                                  {{ calculatePriceWithoutNds(item) | currency({
								symbol: ' ', fractionCount: 2, symbolPosition: 'back'
								}) }}
                                </div>
                          </div>
                           <div class="c-6">
                                <div class="inner-dev">
                                    Valoarea 
                                    <br>
                                    -lei-
                                </div>
                                <div class="inner-dev-2">
                                    5
                                </div>
                                 <div class="td" style="justify-content:center"
                                 v-for="(item, index) 
                                 in saleForDocument.saleItems"
                                :key="index" >
                                <span v-if="item.priceWholesale" class="customSizeItem">{{ calculateSumOfItemWithoutNds(item) | currency({
											symbol: ' ', fractionCount: 2, symbolPosition: 'back'
											}) }}</span>
								<span v-else> </span>
                                </div>
                          </div>
                           <div class="c-7">
                                <div class="inner-dev">
                                     Valoarea 
                                     <br>
                                     T.V.A
                                    <br>
                                    -lei-
                                </div>
                                <div class="inner-dev-2">
                                    6
                                </div>
                                 <div class="td" style="justify-content:center"
                                 v-for="(item, index) 
                                 in saleForDocument.saleItems"
                                :key="index" >
                                  <span v-if="calculateRealCostOfItem(item) > 0" class="customSizeItem">{{ calculateNdsOfItem(item) | currency({
											symbol: ' ', fractionCount: 2, symbolPosition: 'back'
											}) }}</span>
								<span v-else> </span>
                                </div>
                          </div>
                      </div>
                    <footer>
                        <div class="footer">
                            <div class="f-1">
                                Semnatura si
                                <br>
                                stampila
                                <br>
                                furnizorulu
                            </div>
                            <div class="f-2">
                              <ul style="list-style:none">
								  <li>Date privind expeditia:</li>
								  <li>Numele delegatului .......................................................</li>
								  <li>..........................................................................................</li>
								  <li>Buletinul/cartea de ideptitate</li>
								  <li>seria .........nr. .......................(eliberat(a)........................</li>
								  <li>Mijlocul de transport .....................................................</li>
								  <li>nr. ....................................................................................</li>
								  <li>Expedierera s-a facut in prezenta noastra la</li>
								  <li>date de ...................................... .ora .............................</li>
								  <li>Semnaturile ....................................................................</li>
							  </ul>
                            </div>
                            <div class="f-3">
                               <div>
                                    Total
                                    <br>
                                    din care:
                                    <br>
                                    accize
                                </div>
                                 <div>
                                    Semnatura
                                    <br>
                                    de primire
                                </div>
                            </div>
                            <div class="f-4">
                                <div class="top">
                                    <div class="t" >
										<span v-if="totalPriceOfItems > 0" style="font-weight: bold">
											{{ totalPriceOfItems | currency({
										symbol: ' ', fractionCount: 2, symbolPosition: 'back'
										}) }}
										</span>
										<span> </span>
									</div>
                                    <div class="t">
										<span v-if="totalNdsOfItems > 0" style="font-weight: bold">
											{{ totalNdsOfItems | currency({
										symbol: ' ', fractionCount: 2, symbolPosition: 'back'
										}) }}
										</span>
										<span> </span>
									</div>
                                </div> 
                                <div class="mid" >
                                    <div>
										
									</div>
                                    <div>

									</div>
                                </div>
                                <div class="bottom p-2">
                                    Total de plata
                                    <br>
                                    (col.5+col.6)
									<br>
									<b style="line-height:40px; margin-left:55px" v-if="totalPriceOfItems > 0 && totalNdsOfItems > 0">{{(totalPriceOfItems + totalNdsOfItems) | 
										currency({
										symbol: ' ', fractionCount: 2, symbolPosition: 'back'
										})}}</b>
                                </div>
                            </div>

                        </div>

                    </footer>
                </div>
			</b-card>
		</div>
	</b-container>
</template>


<script>
	import {mapActions, mapState} from 'vuex'
	import WhDocument from "../../../../services/wh-document.service";

	export default {
		name: 'RuminyaNakladnoy',

		data() {
			return {
				currentContragentForTransfer: {},
				currentDepartmentForMoneyTransfer: {},
				saldoByYear: {
					currentYear: {},
					lastYear: {},
					totalSaldo: {}
				},
				item: {},
				totalPrice: {
					uzs: 0,
					usd: 0
				},
				priceType: 'uzs',
				income: [],
				totalIncome: {
					uzs: 0,
					usd: 0
				},
				sidebar: {
					open: false,
					close: false
				},
				backTo: null,
				tag5: 'span',
				tag6: 'span',
				tag7: 'span',
				tag4:'span',
				tag81:'span',
				tag82:'span',
				tag83:'span',
				tag9:'span',
				tag31:'span',
				tag32:'span',
				tag33:'span'
			}
		},

		methods: {
			async excelSave() {
				let res = await WhDocument.excelNakladnoyOptom(this.$route.params.id, this.saleForDocument, "ROMANIA")
				const url = URL.createObjectURL(new Blob([res.data], {
					type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
				}))
				const link = document.createElement('a')
				link.href = url
				link.setAttribute('download', 'excel-file')
				document.body.appendChild(link)
				link.click()
			},
			...mapActions('wholesalePos', [
				'getSaleById'
			]),
			goBackToFrom() {
				this.$router.back();
			},
			print() {
				window.print();
			},
			calculateRealCostOfItem(item) {
				/*let sumOfPriceWithoutNds = (item.priceWholesale/1.2) * item.count;
                let sumOfNds = ((item.priceWholesale * item.count) * 0.2)/1.2;*/
				if (item.discountPriceUzs > 0) {
					return item.discountPriceUzs * item.count;
				} else {
					return 0
				}
			},
			calculateNdsOfItem(item) {
				return this.calculateRealCostOfItem(item) / (199/19);
			},
			calculateSumOfItemWithoutNds(item) {
				return this.calculateRealCostOfItem(item) - this.calculateNdsOfItem(item);
			},
			calculatePriceWithoutNds(item) {
				return this.calculateSumOfItemWithoutNds(item) / item.count;
			},
			calculateTotalRealCost() {
				let temp = 0;
				for (let i = 0; i < this.saleForDocument.saleItems.length; i++) {
					temp += this.calculateRealCostOfItem(this.saleForDocument.saleItems[i]);
				}
				return temp;
			}
		},
		async created() {
			await this.getSaleById(this.$route.params.id);
		},
		computed: {
			...mapState('wholesalePos', [
				'saleForDocument'
			]),
			totalPriceOfItems() {
				let temp = 0;
				this.saleForDocument.saleItems.forEach(el => {
					temp += this.calculateSumOfItemWithoutNds(el);
				});
				return temp;
			},
			totalNdsOfItems() {
				let temp = 0;
				this.saleForDocument.saleItems.forEach(el => {
					temp += this.calculateNdsOfItem(el);
				});
				return temp;
			}
		},
		components: {},
	}
</script>

<style scoped lang="scss">
.t {
	display: flex;   
    align-items: center;
	justify-content: center;
}
.td {
    box-sizing: border-box;
    height: 35px;
    display: flex;   
    align-items: center;
}
.footer {
    display: flex;
    height: 5.2cm;
}
.f-1 {
    line-height: 18px;
    width: 16%;
    padding: 12px;
	border-right: 1.5px solid black;
    
}
.f-2 {
    line-height: 18px;
    width: 43%;
	border-right: 1.5px solid black;
	 padding: 12px;
}
.f-3 {
    width:14%;
    border-right: 1.5px solid black;
}
.f-3 {
    div {
        height: 2.4cm;
        line-height: 18px;
        padding: 10px;
            &:nth-child(1) {
            border-bottom: 1.5px solid black;
        }
    }
}
.f-4 {
    width:28%;
     line-height: 18px;
    .top , .mid {
		flex-direction: row;
		display: flex;
        width: 100%;
        height: 1.2cm;
        border-bottom: 1.5px solid black;
        div {
			width: 50%;
            height: 100%;
            &:nth-child(1) {
                border-right: 1.5px solid black;
                width: 50%;
                height: 100%;
            }
        }
    }
    .bottom {
        height: 2.8cm;
    }
}

.inner-dev {
    border-bottom: 1.5px solid black;
    height: 1.8cm;
    box-sizing: border-box;
    justify-content: center;
    display: flex;   
    align-items: center;
    font-weight: bold;
}
.inner-dev-2 {
    border-bottom: 1.5px solid black;
    height: 20px;
    font-weight: bold;
}
.body-wrapped {
    flex-direction: row;
    display: flex;
    min-height:16cm; 
    min-width:21.5cm !important
}

.c-1, .c-2, .c-3, .c-4, .c-5, .c-6 {
    border-bottom: 1.5px solid black;
    line-height: 16px;
    border-top:1.5px solid black;
    width: 6%;
    min-height: inherit;
    border-right: 1.5px solid black;
    text-align: center;
    
    
}
.c-7 {
    border-bottom: 1.5px solid black;
    line-height: 16px;
    text-align: center;
    
    min-height: inherit;
    border-top: 1.5px solid black;
     
}
.c-2 {
    width: 35%;
}
.c-3 {
    width: 7%;
}
.c-4 {
    width: 11%;
}
.c-5, .c-6, .c-7 {
    width:14%
}

.ul-third { 
    li {
        line-height: 26px;
    }
}
h4 {
    margin:0
}
ul {
    margin: 0;
    padding: 0;
}

.bottom-fiscal {
    border:1.5px solid black;
}
.left-box {
    line-height: 18px;
    margin-top:-7px;
    padding-top:0px;
    padding-left: 20px;
    padding-right: 20px; 
}
.wrapped {
    border: 1.5px solid black;
    min-height:29.7cm; 
    min-width:21cm !important
}
@media print {
    .hidden-print {
        display: none;
    }
    table.table-bordered > .thead-first > tr > th{
        border:0px solid white !important;
    }   
    .card {
        box-shadow: none;
    }
	}
</style>
